var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 27.521,
    viewBox: "0 0 32.002 27.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.1,18.13l2.181.541,1.642-2.578-3.12-.771a1.447,1.447,0,1,0-.7,2.808Zm28.466.417-7.141,6.426-8.4-6.5a1.435,1.435,0,0,0-.541-.259l-1.117-.278-1.643,2.578,1.76.437,9.115,7.053a1.469,1.469,0,0,0,1.868-.069l8.045-7.243a1.44,1.44,0,0,0,.1-2.043,1.458,1.458,0,0,0-2.054-.1ZM13.894,11.488l7.819,5.006A1.462,1.462,0,0,0,23.7,16.1L31.74,4.513A1.442,1.442,0,0,0,31.37,2.5a1.457,1.457,0,0,0-2.024.368L22.1,13.3,14.235,8.264a1.455,1.455,0,0,0-2.015.443L.225,27.534A1.453,1.453,0,0,0,2.68,29.088l11.213-17.6Z",
    transform: "translate(0.002 -2.239)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetLine);
export default __webpack_public_path__ + "static/media/widget-line.c9414ca3.svg";
export { ForwardRef as ReactComponent };